import * as React from 'react'

interface FollowContextType {
  recentlyFollowedUsers: Set<string>
  allFollowedUsers: Set<string>
  followUser: (userId: string) => void
  unfollowUser: (userId: string) => void
  addUserToAllFollowed: (userId: string) => void
  removeUserFromAllFollowed: (userId: string) => void
}

const FollowContext = React.createContext<FollowContextType>(null!)

export const FollowProvider = ({ children }: { children: React.ReactNode }) => {
  const [recentlyFollowedUsers, setRecentlyFollowedUsers] = React.useState<Set<string>>(new Set())
  const [allFollowedUsers, setFollowedUsers] = React.useState<Set<string>>(new Set())

  const followUser = (userId: string) => {
    setRecentlyFollowedUsers(prev => new Set(prev).add(userId))
  }

  const unfollowUser = (userId: string) => {
    setRecentlyFollowedUsers(prev => {
      const updatedSet = new Set(prev)
      updatedSet.delete(userId)
      return updatedSet
    })
  }

  const addUserToAllFollowed = (userId: string) => {
    setFollowedUsers(prev => new Set(prev).add(userId))
  }

  const removeUserFromAllFollowed = (userId: string) => {
    setFollowedUsers(prev => {
      const updatedSet = new Set(prev)
      updatedSet.delete(userId)
      return updatedSet
    })
  }

  return (
    <FollowContext.Provider
      value={{
        recentlyFollowedUsers,
        followUser,
        unfollowUser,
        allFollowedUsers,
        addUserToAllFollowed,
        removeUserFromAllFollowed,
      }}
    >
      {children}
    </FollowContext.Provider>
  )
}

export const useRecentlyFollowed = () => React.useContext(FollowContext)
